module.exports = __webpack_public_path__ + "static/media/Logo.f2f08ac9.png";